<template>
  <div class="row items-center">
    <span v-if="conf && conf.config && conf.config.prefix" class="q-mr-sm">
      {{ conf.config.prefix }}
    </span>
    <span
      :style="{
        'white-space': conf.label.length < 20 ? 'nowrap' : 'unset',
      }"
    >
      {{ conf.label }}
    </span>
    <span v-if="conf && conf.config && conf.config.suffix" class="q-ml-sm">
      {{ conf.config.suffix }}
    </span>
  </div>
</template>

<script>
import QuestionChoiceMixin from "./question-choice.mixin";
export default {
  mixins: [QuestionChoiceMixin],
};
</script>
